import type { Hours, Milliseconds } from '@ankr.com/raas-types';

import { IS_PROD } from './environment';

export const PROJECT_KEY = import.meta.env.VITE_PROJECT_KEY;
export const PUBLIC_DIR = import.meta.env.VITE_PUBLIC_DIR;
export const HOMEPAGE = import.meta.env.VITE_HOMEPAGE;
export const PROJECT_TITLE = import.meta.env.VITE_TITLE;

export const STAKING_URL = import.meta.env.VITE_STAKING_URL;
export const STAKING_DEFI_URL = import.meta.env.VITE_STAKING_DEFI_URL;
export const STAKING_DOCS_URL = import.meta.env.VITE_STAKING_DOCS_URL;
export const USER_SUPPORT_URL = import.meta.env.VITE_USER_SUPPORT_URL;
export const HUBSPOT_URL = import.meta.env.VITE_HUBSPOT_URL;
export const INTEGRATIONS_PROMO_URL = import.meta.env
  .VITE_INTEGRATIONS_PROMO_URL;
export const GRANTS_DOCS_URL = import.meta.env.VITE_GRANTS_DOCS_URL;

export const POLKADOT_CORETIME_DOCS_URL = import.meta.env
  .VITE_POLKADOT_CORETIME_DOCS_URL;
export const POLKADOT_PURCHASE_CORETIME_URL = import.meta.env
  .VITE_POLKADOT_PURCHASE_CORETIME_URL;

export const CUSTOM_GAS_TOKEN_DOCS_URL = import.meta.env
  .VITE_CUSTOM_GAS_TOKEN_DOCS_URL;

export const SELF_SEQUENCER_DOCS_URL = import.meta.env
  .VITE_SELF_SEQUENCER_DOCS_URL;
export const ROLLUP_DEPLOYMENT_DOCS_URL = import.meta.env
  .VITE_ROLLUP_DEPLOYMENT_DOCS_URL;

export const ROLLUP_ARBITRUM_DEPLOYMENT_BRIDGE_DOCS_URL = import.meta.env
  .VITE_ROLLUP_ARBITRUM_DEPLOYMENT_BRIDGE_DOCS_URL;

export const ROLLUP_OPTIMISM_DEPLOYMENT_BRIDGE_DOCS_URL = import.meta.env
  .VITE_ROLLUP_OPTIMISM_DEPLOYMENT_BRIDGE_DOCS_URL;

export const ALLOW_CRYPTO_PAYMENTS =
  import.meta.env.VITE_ALLOW_CRYPTO_PAYMENTS === 'true';
export const ALLOW_ANKR_TOKEN_PAYMENTS =
  import.meta.env.VITE_ALLOW_ANKR_TOKEN_PAYMENTS === 'true';

export const ALLOW_BLOCKEXPLORER_CUSTOMIZATION =
  import.meta.env.VITE_ALLOW_BLOCKEXPLORER_CUSTOMIZATION === 'true';

export const POWERED_BY_URL = 'https://www.ankr.com/rollup-as-a-service-raas/';

export const TERMS_OF_USE_URL = `${HOMEPAGE}static/doc/Asphere_-_Terms_of_Service_-_No_Code_Deployer_App.pdf`;

export const CMS_MANUAL_DEPLOYMENTS_API_URL = import.meta.env
  .VITE_CMS_MANUAL_DEPLOYMENTS_API_URL;

export const ANKR_TOKEN_PAYMENTS_PERCENT_DISCOUNT = 10;

export const ROLLUP_TESTNET_DURATION: Hours = 48;

export const SELF_SEQUENCER_FUNDS = '0.7 ETH';

export const ANKR_ETH_FOR_TESTNET_AMOUNT = 1;

export const ROLLUP_POLLING_INTERVAL: Milliseconds = 5000;

const MAX_FREE_TESTNET_ROLLUPS_STAGE = 1;
const MAX_FREE_TESTNET_ROLLUPS_PROD = 1;
export const MAX_FREE_TESTNET_ROLLUPS = IS_PROD
  ? MAX_FREE_TESTNET_ROLLUPS_PROD
  : MAX_FREE_TESTNET_ROLLUPS_STAGE;

export const MAX_CHAIN_ID = 1000000000;

export const METAMASK_INSTALL_URL = 'https://metamask.io/download/';
